import {
  ProfileMenu,
  ReportRefresh,
  SessionSwitcher,
} from "@/components/header/header-utils";
import { NotificationsBell } from "@/components/header/NotificationsBell";
import { usePage } from "@/components/page/PageContext";
import { useSidebar } from "@/components/ui/sidebar";
import { Menu } from "lucide-react";

export function EnhancedSidebarTrigger() {
  const { toggleSidebar } = useSidebar();

  return (
    <button
      onClick={toggleSidebar}
      className="p-2 rounded-md hover:bg-gray-700 transition-colors duration-200 flex items-center justify-center mt-1"
      aria-label="Toggle sidebar"
    >
      <Menu size={20} className="text-gray-300" />
    </button>
  );
}

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function HeaderBar3() {
  const { titles } = usePage();

  return (
    <div className="w-full bg-gray-800 flex p-2 lg:p-4 items-center">
      <EnhancedSidebarTrigger />

      <div className="flex-grow">
        {titles.length > 0 && (
          <div className="flex items-center">
            <h1 className="text-lg lg:text-2xl font-semibold text-white ml-1 lg:ml-3">
              {titles[titles.length - 1]}
            </h1>
          </div>
        )}
      </div>

      <div>
        <ReportRefresh />
      </div>
      <div>
        <SessionSwitcher />
      </div>
      <div>
        <ProfileMenu />
      </div>
      <div>
        <NotificationsBell />
      </div>
    </div>
  );
}
